import { PHONE_NUMBER } from '@/constants/Common'
import { LocaleEvent } from '../en/event'

const event: LocaleEvent = {
  showUnclaimedAccountsDesc: '无法选择的账号是未认领或已受邀的。受影响的玩家必须注册账号才能被选择',
  events: '活动',
  eventsNearMe: '我附近的比赛',
  myEvents: '我的比赛',
  explore: '探索',
  eventStatus: '比赛现状',
  addABracket: '添加项目',
  editEvent: '编辑比赛',
  endEvent: '结束比赛',
  addAnAnnouncement: '添加公告',
  submitPayment: '提交付款',
  register: '注册',
  registrationClosed: '注册已结束',
  registered: '已注册',
  aboutTheEvent: '关于比赛',
  announcements: '公告',
  noMoreAnnouncements: '暂无新公告',
  eventRegistration: '比赛注册',
  clubMembership: '俱乐部会员',
  clubMembershipQuestion: '你是主办俱乐部的成员吗？',
  contactDetails: '联系方式',
  selectYourBrackets: '选择您的项目',
  competitionDates: '比赛日期',
  invitedPlayer: '受邀选手',
  invitedPlayerTooltip: '您的搭档已经邀请您参加此次活动。若要接受或拒绝此邀请，请转到您的首页的“我的队伍”部分',
  ineligibleBracket: '不合格项目',
  registrationFull: '注册已满',
  registerForWaitlist: '登记候补名单',
  totalPaymentDue: '应付款总额(1个比赛)',
  inviteSent: '邀请已发送',
  offers: '提议',
  eventPolicies: '比赛政策',
  iAgreeText: '我已经阅读并同意',
  healthAndSafetyPolicy: '健康和安全政策',
  liabilityPolicy: '责任政策',
  registeredSuccessfully: '您已经付款并成功注册。',
  registrationComplete: '注册完成',
  registrationCompleteText: '您的注册已完成。您可以从您的赛事页面编辑您的注册详细信息，该页面可通过主页访问。',
  continueToPayment: '继续付款',
  addPhoneNumber: '添加手机号码',
  editPhoneNumber: '编辑手机号码',
  bracketDetails: '项目详情',
  players: '选手',
  teams: '队伍',
  matches: '一些比赛',
  partnerConfirmed: '搭档已确认',
  noPartnerSelected: '未选择搭档',
  partnerPending: '搭档待定',
  viewDraws: '查看图表',
  seedMatches: '自动生成比赛',
  editBracket: '编辑此项目',
  endBracket: '结束次项目',
  endBracketModalDesc: '一旦您选择将此队伍标记为完成，您将无法再对其进行更改。',
  withdraw: '退出',
  editPartner: '编辑搭档',
  removePartner: '删除搭档',
  removePartnerFirstDesc: '你确定要拒绝吗',
  removePartnerSendDesc: '邀请参加此比赛？',
  addPartner: '添加搭档',
  reopenBracket: '重开此项目',
  confirmWithdrawFromBracket: '您确定要从次项目中退出么？',
  contactTheEventOrganizer: '如果您计划申请退款，请在退出前联系赛事组织者。',
  toRegisterFor: '注册',
  answerCompleteThePrecess: '回答以下详细信息以完成申请或处理',
  declineInvite: '拒绝邀请',
  declineInviteFirstDesc: '你确定要拒绝吗',
  declineInviteSecondDesc: '邀请参加此比赛？',
  exitTheQueue: '退出队列',
  exitTheQueueDesc:
    '如果您已经找到了下一场比赛的场地，请退出在线等候队列。一旦你选择退出等候队列，你必须亲自到球场等候并确保球场是可用的',
  WL: '赢/输',
  pointDiff: '分数差异',
  waitlisted: '候补名单',
  switchBracket: '调换项目',
  switchBrackets: '调换多个项目',
  switch: '调换',
  addParticipant: '添加参与者',
  switchBracketsConfirmation: '您确定要为所选团队调换比赛项目吗？',
  withdrawPlayer: '撤销选手',
  confirmWithdrawPlayerFirstText: '您确定要删除吗',
  confirmWithdrawPlayerSecondText: '从这个项目？',
  withdrawRefund: '撤销/退款',
  addABracketParticipant: '添加次项目参与者',
  selectAPlayer: '从下面的列表中选择一个选手',
  memberOfHostClub: '选手是赛事主办方俱乐部的成员吗？',
  selectBracketsToSwitch: '选择要调换的项目',
  confirmTeam: '确认小组团队',
  editTeam: '编辑小组团队',
  splitTeam: '拆分小组团队',
  replace: '代替',
  addAPartner: '添加搭档',
  addAPartnerDesc:
    '如果您的搭档已经是DUPR用户，您可以通过搜索此目录将他们添加到您的组队中。如果您的搭档没有在DUPR注册，您可以通过电子邮件邀请他们加入您的组队',
  teamConfirmed: '团队确认',
  teamPending: '团队待定',
  replaceTeamDesc:
    '您可以将此已注册团队替换为此组别的任何其他等待列表中的团队。一旦确认要替换，将自动在初始项目和目标项目中重新生成匹配，并且是从下面提到的团队中选择。',
  confirmEditTeam: '您确定要编辑团队吗？',
  confirmThisTeams: '您要确认此团队吗？',
  createTeam: '创建团队',
  playersDifferentGenders: '选手必须是不同的性别',
  unmatchedTeams: '未匹配到的队伍',
  pleaseSelectAnyTwoPlayers: '请从列表中选择任意两名选手组队',
  youSelectedTwoPlayersSameGender:
    '您选择了两位相同性别的选手。因为这是一个混合组别，所以所有队伍必须包含一名男性和一名女性。',
  thisTeamCannotCreated: '无法创建此团队，因为',
  and: '并且',
  isOnTheWaitlist: '在候选名单上。请从非候补选手中创建一个团队。',
  afterYouConfirm: '确认此选择后，这些选手将被移至“团队”选项',
  forfeit: '弃赛',
  bye: '再见',
  forfeitMatch: '弃赛',
  forfeitMatchDesc: '请选择放弃比赛的队伍。你选择的队伍将被认为输了这场比赛。',
  teamA: 'A队',
  teamB: 'B队',
  markAsForfeit: '标记为弃权',
  youCanAddScores: '您可以在这些日期之间添加分数',
  titleSubmitScoreModal: '提交所有比赛的分数',
  scoreWarningMessage:
    '您必须完成比赛，并立即提交比赛中所有场次的分数。如果您计划提交这场比赛中其他场次的分数，请返回。',
  editingScoresTitle: '编辑已结束比赛的分数',
  editingScoresFirstDesc: '您正在编辑目前已结束比赛的分数。这项赛事的排名和未完成的比赛不会受影响。',
  editingScoresSecondDesc: ' You will loose the integrity of data in Diagram and standings of this event. ',
  stillContinue: '您还想继续吗？',
  submitScores: '提交分数',
  submittingScoresTitle: '提交这些新分数将影响已经安排设置的比赛',
  submittingScoresFirstDesc: '您选择了新的获胜者，下一轮的一些比赛将重新安排。',
  editScores: '编辑分数',
  addScores: '添加分数',
  deleteBracketMatchDesc: '如果您删除此比赛，您将不得不重新输入分数，这会影响您的评分。',
  validateMatch: '验证比赛',
  validate: '验证',
  substitutes: '替补',
  selectParticipant: '从下面的列表中选择一个参与者。',
  totalAmountPaid: '支付总额',
  showDetail: '显示详细数据',
  playerStatus: '选手状态',
  paymentStatus: '付款状态',
  amountPaid: '支出金额',
  amountRefunded: '退款金额',
  bracketName: '项目名称',
  pricing: '价格',
  pricingDesc:
    '选手必须支付比赛报名费和每个组别的费用才能参加比赛。根据您是否是主办俱乐部的成员，比赛定价也可能有所不同。',
  eventEntryFee: '比赛报名费',
  bracketPrice: '比赛单项费',
  importantDates: '重要日期',
  importantDatesDesc:
    '选手必须支付比赛报名费和每个组别的费用才能参加比赛。根据您是否是主办俱乐部的成员，比赛定价也可能有所不同。',
  registrationDates: '注册日期',
  registrationLimit: '注册限制',
  numberTeamsPermitted: '允许的团队数量',
  waitlistAllowance: '等候名单津贴',
  allowedWaitlist: '允许加入等候名单的队伍',
  bracketType: '单项类型',
  roundRobin: '小组循环赛',
  roundRobinDesc:
    '小组循环锦标赛是一种每个参赛者依次与所有其他参赛者相遇的循环赛制。循环赛不同于淘汰赛，淘汰赛的参与者在输了一定次数后就会被淘汰。',
  waterfall: '瀑布锦标赛',
  waterfallDesc:
    '16支队伍的瀑布赛制确保每支队伍都能进行4场比赛。赛程表以指南针的8个方向标记（北、南、东、西、东北、西北、东南、西南）。在每场比赛中，每支队伍都会与胜负记录完全相同的队伍进行对决。',
  flexLeague: '联盟赛',
  flexLeagueDesc:
    'DUPR Flex联赛类似于小组循环赛是每个参赛者依次与所有其他参赛者相遇的比赛。这种赛制适合选手在有充裕的时间下组织的比赛，因为这种赛制通常会持续很长时间。',
  numberCourts: '球场数量',
  playerGroup: '赛事选手群',
  playerRules: '选手规则',
  skillLevel: '技术程度',
  ageGroup: '年龄组',
  menDoubles: '选手将两人一组进行比赛。每队必须由两名男性队员组成。',
  womenDoubles: '选手将两人一组进行比赛。每队必须由2名女队员组成。',
  mixedDoubles: '选手将两人一组进行比赛。每个队必须由一名女队员和一名男队员组成。',
  openDoubles: '选手将两人一组进行比赛。球员可以是任何性别的组合',
  acceptPartner: '接受搭档',
  leagueConsentTitle: '您的联系信息将被共享',
  leagueConsentDesc:
    '一旦您注册了这场比赛，您的电子邮件和电话号码将只对注册此比赛的其他选手可见。这使得选手可以互相联系比赛日程。',
  noQualifyingBrackets: '没有限定项目',
  noQualifyingBracketsTitle: '根据您的DUPR评分、年龄和性别资料，您不符合参加本次比赛中的任何公开项目',
  pleaseContactEventAdministrator: '请通过以下方式联系赛事组织者',
  pleaseContactText: '如果您认为这是个错误。',
  step1: '步骤1:请选择一个选项并继续',
  refundOnly: '仅退款',
  withdrawAndRefund: '撤销和退款',
  step2: '第二步',
  event: '比赛',
  bracketsOf: '比赛项目',
  total: '总数',
  paymentPending: '付款待定',
  freeEvent: '免费赛事',
  fullyRefundedEvent: '全额退款赛事',
  partiallyRefundedEvent: '部分退款赛事',
  fullyRefunded: '全额退款',
  splitTeamFirst: '首先拆分小组团队',
  freeBracket: '免费项目',
  partiallyRefunded: '部分退款',
  viewQualifyingPartners: '查看合格的搭档',
  viewQualifyingPartnersDesc: '该DUPR用户列表将仅显示根据其声明的评级、年龄和性别符合此赛事单项要求的潜在搭档',
  joiningWaitlist: '您加入了等候列表',
  joiningWaitlistDesc: '您已选择加入至少一个比赛单项的等候名单。如果你被移出此候选名单，赛事管理人员会及时通知您',
  fromSelectedBrackets: '从选定的赛事项目中？',
  sureRefundATotalAmount: '您确定要退还总额是',
  sureRemove: '您确定要删除吗',
  seedMatchesDesc: '点击“组建比赛”来分组',
  createMatches: '创建比赛',
  seeds: '种子选手',
  reseedMatches: '重组比赛',
  bracketCreated: '创建小组',
  endEventModalDesc: '一旦您选择将此活动标记为完成，您将无法再对其进行更改。该活动将被永久标记为非活动状态。',
  endEventTitleModal: '您确定要结束此活动吗？',
  reopenBracketDesc: '一旦重新打开此比赛项后，在此项比赛结束日期之前，您可以添加分数和编辑信息。',
  addABracketParticipantDesc: '无人认领或未被邀请的账号将无法被安排比赛，受影响的选手必须注册一个帐号才能被安排比赛',
  youLikeToCreateTeam: '您确定要创建此团队吗？',
  submittingScoresSecondDesc:
    '如果选手已经在场上，并且您不想编辑当前的比赛，请单击“返回”。活动结束后，您可以随时编辑个人比赛的分数，如果你想继续新的比赛，请提交分数。',
  validateMatchDesc: `您确定要验证这些分数吗？如果是这样，比赛结束并且选手等级将会更新。如果这些分数不正确，请联系活动负责人或发短信 ${PHONE_NUMBER} 告知正确的分数`,
  endBracketModalTitle: '您确定要结束此比赛项目么？',
  moveToUnmatchedTab:
    '在球员退赛以后，他们将被移至“未参赛选手”选项卡。从那里，您可以将该球员添加到另一个组队或将其从赛事活动中完全退出。',
}

export default event
